import { isPartnershipEligible } from '@shared/partnershipEligibility';
import { FundingPolicyType } from '@shared';
import { cn } from '@/lib';
import { Check } from 'lucide-react';

interface PartnershipEligibleBadgeProps {
  policyType: number;
  state: string;
  primaryAge: number;
  bioPercent: string | number | null;
  isCompoundInflation?: boolean;
  className?: string;
  appearance?: 'badge' | 'inline';
}

export function PartnershipEligibleBadge({
  policyType,
  state,
  primaryAge,
  bioPercent,
  isCompoundInflation,
  className,
  appearance = 'badge',
}: PartnershipEligibleBadgeProps) {
  if (policyType !== FundingPolicyType.careScoutCareAssurance) {
    return null;
  }

  const eligible = isPartnershipEligible({
    state,
    ageAtIssue: primaryAge,
    bioPercent,
    policyType,
    isCompoundInflation,
  });

  if (!eligible) {
    return null;
  }

  const isInline = appearance === 'inline';

  return (
    <span
      className={cn(
        'inline-flex w-fit items-center font-medium',
        isInline
          ? 'text-foreground gap-1.5 text-sm'
          : 'min-h-7 justify-center rounded-full border border-purple-200 bg-purple-50 px-3 py-1 text-xs text-purple-700',
        className,
      )}
      data-testid="partnership-eligible-badge"
    >
      {isInline && <Check className="size-4 shrink-0 text-green-600" />}
      Partnership Eligible
      <sup className="ml-0.5 text-[9px] leading-none">**</sup>
    </span>
  );
}
